// Model.js
// -----------------------
// @module Case
define("MHI.BasicEnhancements.CustomCategoryFields.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
         //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/CustomCategoryFields/SuiteScript2/CustomCategoryFields.Service.ss"
            ),
            true
        )
        
});
});
